// import React, { useEffect, useState } from 'react'
// import { Button, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap'
// import {
//   BsList,
//   BsPlus,
//   BsPerson,
//   BsGrid,
//   BsPeople,
//   BsHourglassSplit,
//   BsPersonPlus,
//   BsCalendarEvent,
//   BsXCircle,
//   BsPlusCircle,
//   BsFileEarmarkSpreadsheet,
// } from 'react-icons/bs'
// import { CiLogout } from 'react-icons/ci'
// import '../TmsStyles/TmsSidebar.css'
// import AddTrainingModal from './AddTrainingModal'
// import AddUserModal from './AddUserModal'
// import { useNavigate } from 'react-router-dom'
// import axios from 'axios'

// const TmsSidebar = () => {
//   const [collapsed, setCollapsed] = useState(false)
//   const [isTrainingModalOpen, setTrainingModalOpen] = useState(false)
//   const [isAddUserModalOpen, setAddUserModalOpen] = useState(false)
//   const navigate = useNavigate()

//   const [links, setLink] = useState([
//     { href: '/db-shiksha/kaas/tmsdashboard', icon: <BsGrid size={20} />, label: 'Dashboard' },
//     { href: '/db-shiksha/kaas/training', icon: <BsPlus size={20} />, label: 'Training' },
//     {
//       href: '/db-shiksha/kaas/pendingtraining',
//       icon: <BsHourglassSplit size={20} />,
//       label: 'Pending Training',
//     },
//     {
//       href: '/db-shiksha/kaas/upcomingtraining',
//       icon: <BsCalendarEvent size={20} />,
//       label: 'Upcoming Training',
//     },
//     {
//       href: '/db-shiksha/kaas/declinedtraining',
//       icon: <BsXCircle size={20} />,
//       label: 'Declined Training',
//     },
//     {
//       href: '/db-shiksha/kaas/participants',
//       icon: <BsPeople size={20} />,
//       label: 'Participants',
//     },
//     {
//       href: '/db-shiksha/kaas/addparticipants',
//       icon: <BsPersonPlus size={20} />,
//       label: 'Add Participants',
//     },
//     {
//       href: '/db-shiksha/kaas/createassessment',
//       icon: <BsPlusCircle size={20} />,
//       label: 'Create Assessment',
//     },
//     {
//       href: '/db-shiksha/kaas/result',
//       icon: <BsFileEarmarkSpreadsheet size={20} />,
//       label: 'Result',
//     },
//     { href: '/db-shiksha/kaas/Log', icon: <CiLogout size={20} />, label: 'Logout' },
//   ])

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed)
//   }
//   const URL = 'https://tdtlworld.com/dss-kaas-backend/'
//   const token = localStorage.getItem('jwttoken')

//   const allowedLinks = ['/db-shiksha/kaas/results', '/db-shiksha/kaas/log']

//   useEffect(() => {
//     const role = localStorage.getItem('role')
//     if (role === 'Client' || role === 'Trainer') {
//       setLink(links.filter((link) => allowedLinks.includes(link.href)))
//     }
//   }, [])

//   const logout = () => {
//     axios
//       .post(
//         `${URL}auth/logout/`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then(() => {
//         localStorage.removeItem('jwttoken')
//         navigate('/db-shiksha/kaas/Log')
//       })
//       .catch((reason) => {
//         alert(reason)
//         localStorage.removeItem('jwttoken')
//         navigate('/db-shiksha/kaas/Log')
//       })
//   }

//   return (
//     <div
//       style={{ display: 'flex', height: '100vh', backgroundColor: '#F8F9FA' }}
//     >
//       <aside
//         id='sidebar'
//         className={`bg-light ${collapsed ? 'collapsed' : ''}`}
//         style={{
//           backgroundColor: '#ffffff',
//           height: '105vh',
//           width: collapsed ? '60px' : '250px',
//           transition: 'width 0.3s ease',
//           boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)',
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'column',
//           padding: '10px 0',
//           margin: 0,
//         }}
//       >
//         <div
//           className='d-flex justify-content-between align-items-center px-3 py-2'
//           style={{ borderBottom: '1px solid #ddd' }}
//         >
//           <h5
//             className='text-dark m-0'
//             style={{ fontSize: '1.2rem', fontWeight: 'bold' }}
//           >
//             {!collapsed && ''}
//           </h5>
//           <button
//             onClick={toggleSidebar}
//             className='btn btn-light'
//             style={{ padding: '5px 8px', borderRadius: '50%' }}
//           >
//             <BsList size={20} />
//           </button>
//         </div>

//         <Nav defaultActiveKey='/db-shiksha/kaas/home' className='flex-column mt-3' style={{}}>
//           {!collapsed && (
//             <div className='mb-3 px-2'>
//               <Button
//                 variant='primary'
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   marginBottom: '10px',
//                   fontWeight: '500',
//                   fontSize: '0.95rem',
//                   padding: '10px',
//                 }}
//                 onClick={() => setTrainingModalOpen(true)}
//                 disabled={localStorage.getItem('role') !== 'Admin'}
//               >
//                 <BsPlus className='me-2' /> Add Training
//               </Button>
//               <AddTrainingModal
//                 isOpen={isTrainingModalOpen}
//                 onClose={() => setTrainingModalOpen(false)}
//               />

//               <Button
//                 variant='secondary'
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: '500',
//                   fontSize: '0.95rem',
//                   padding: '10px',
//                 }}
//                 onClick={() => setAddUserModalOpen(true)}
//                 disabled={localStorage.getItem('role') !== 'Admin'}
//               >
//                 <BsPerson className='me-2' /> Add User
//               </Button>
//               <AddUserModal
//                 show={isAddUserModalOpen}
//                 handleClose={() => setAddUserModalOpen(false)}
//               />
//             </div>
//           )}

//           {links.map((item, index) => (
//             <Nav.Item key={index} className='tnav-item'>
//               <OverlayTrigger
//                 placement='right'
//                 overlay={<Tooltip>{item.label}</Tooltip>}
//               >
//                 <Nav.Link
//                   href={item.href}
//                   className='d-flex align-items-center'
//                   style={{
//                     color: '#333',
//                     padding: '8px 15px',
//                     borderRadius: '5px',
//                     justifyContent: collapsed ? 'center' : 'flex-start', // Center icons when collapsed
//                     // marginRight: "100px"
//                   }}
//                 >
//                   {item.icon}
//                   {!collapsed && (
//                     <span
//                       className='ms-3'
//                       style={{ fontSize: '0.95rem', fontWeight: '500' }}
//                     >
//                       {item.label}
//                     </span>
//                   )}
//                 </Nav.Link>
//               </OverlayTrigger>
//             </Nav.Item>
//           ))}
//         </Nav>
//       </aside>
//     </div>
//   )
// }

// export default TmsSidebar

import React, { useEffect, useState } from 'react';
import { Button, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  BsList,
  BsPlus,
  BsPerson,
  BsGrid,
  BsPeople,
  BsHourglassSplit,
  BsPersonPlus,
  BsCalendarEvent,
  BsXCircle,
  BsPlusCircle,
  BsFileEarmarkSpreadsheet,
  BsBoxArrowUpRight,
} from 'react-icons/bs';
import { CiLogout } from 'react-icons/ci';
import { useLocation } from 'react-router-dom';
import AddTrainingModal from './AddTrainingModal';
import AddUserModal from './AddUserModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";
import { encryptCredentials, isEncryptionSupported } from "../../../utils/encryptionHelper";

const TmsSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isTrainingModalOpen, setTrainingModalOpen] = useState(false);
  const [isAddUserModalOpen, setAddUserModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [links, setLink] = useState([
    { href: '/db-shiksha/kaas/admin/tmsDashboard', icon: <BsGrid size={20} />, label: 'Dashboard' },
    { href: '/db-shiksha/kaas/admin/training', icon: <BsPlus size={20} />, label: 'Training' },
    {
      href: '/db-shiksha/kaas/admin/pendingTraining',
      icon: <BsHourglassSplit size={20} />,
      label: 'Pending Training',
    },
    {
      href: '/db-shiksha/kaas/admin/upcomingTraining',
      icon: <BsCalendarEvent size={20} />,
      label: 'Upcoming Training',
    },
    {
      href: '/db-shiksha/kaas/admin/declinedTraining',
      icon: <BsXCircle size={20} />,
      label: 'Declined Training',
    },
    {
      href: '/db-shiksha/kaas/admin/participants',
      icon: <BsPeople size={20} />,
      label: 'Participants',
    },
    {
      href: '/db-shiksha/kaas/admin/addParticipants',
      icon: <BsPersonPlus size={20} />,
      label: 'Add Participants',
    },
    {
      href: '/db-shiksha/kaas/admin/createAssessment',
      icon: <BsPlusCircle size={20} />,
      label: 'Create Assessment',
    },
    {
      href: '/db-shiksha/kaas/admin/result',
      icon: <BsFileEarmarkSpreadsheet size={20} />,
      label: 'Result',
    },
    // Project Navigation Section
        {
          href: '/db-shiksha/aaas/',
          icon: <BsBoxArrowUpRight size={20} />,
          label: 'AaaS Platform',
          external: true,
        },
        {
          href: '/db-shiksha/gatep/',
          icon: <BsBoxArrowUpRight size={20} />,
          label: 'GateP Platform',
          external: true,
        },
    { href: '/db-shiksha/kaas/login', icon: <CiLogout size={20} />, label: 'Logout' },
  ]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const URL = 'https://tdtlworld.com/dss-kaas-backend/';
  const token = localStorage.getItem('jwttoken');
  const allowedLinks = ['/db-shiksha/kaas/admin/result', '/db-shiksha/kaas/login'];

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role === 'Client' || role === 'Trainer') {
      setLink(links.filter((link) => allowedLinks.includes(link.href)));
    }
  }, []);

  const logout = () => {
    // Clear all storage first
    localStorage.clear();
    sessionStorage.clear();
    
    // Clear all cookies
    const cookies = document.cookie.split(";");
    cookies.forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/db-shiksha/kaas/admin/;`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/aaas/;`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/gatep/;`;
    });
    
    // Try to call logout API if token exists
    if (token) {
      axios
        .post(
          `${URL}auth/logout/`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .catch((reason) => {
          console.error("Logout API error:", reason);
        });
    }
    
    console.log('[KaaS TMS Logout] All storage and cookies cleared');
    
    // Redirect to KaaS login page
    window.location.href = "/db-shiksha/kaas/login";
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Fixed Sidebar */}
      <aside
        style={{
          background: 'linear-gradient(180deg, #1E1A78 0%, #3A0CA3 100%)',
          height: '100vh',
          width: collapsed ? '70px' : '250px',
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)',
          transition: 'width 0.3s ease-in-out',
        }}
      >
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(135deg, rgba(30, 26, 120, 0.95) 0%, rgba(58, 12, 163, 0.95) 100%)",
          zIndex: 0,
        }}></div>
        {/* Header */}
       <div
  style={{
    position: 'relative',
    padding: '12px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  {/* Centered Title */}
  {!collapsed && (
    <h5
      style={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'white',
        margin: 0,
        fontSize: '1.1rem',
        fontWeight: '600',
      }}
    >
      TMS Menu
    </h5>
  )}

  {/* Toggle Button in top-right */}
  <button
    onClick={toggleSidebar}
    style={{
      position: 'absolute',
      right: '12px',
      background: 'rgba(255,255,255,0.1)',
      border: 'none',
      borderRadius: '50%',
      color: 'white',
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    }}
  >
    <BsList size={20} />
  </button>
</div>


        {/* Scrollable Content */}
        <div style={{ 
          flex: 1,
          overflowY: 'auto',
          padding: '8px',
          position: 'relative',
          zIndex: 1,
        }}>
          <style>{`
            div[style*="overflowY"]::-webkit-scrollbar {
              width: 6px;
            }
            div[style*="overflowY"]::-webkit-scrollbar-track {
              background: rgba(255, 255, 255, 0.05);
              border-radius: 10px;
            }
            div[style*="overflowY"]::-webkit-scrollbar-thumb {
              background: rgba(255, 255, 255, 0.2);
              border-radius: 10px;
              transition: background-color 0.3s ease-in-out;
            }
            div[style*="overflowY"]::-webkit-scrollbar-thumb:hover {
              background: rgba(255, 255, 255, 0.3);
            }
          `}</style>
          {/* Buttons */}
          {!collapsed && (
            <div style={{ marginBottom: '12px' }}>
              <Button
                style={{
                  width: '100%',
                  padding: '12px',
                  marginBottom: '10px',
                  background: '#5E17EB',
                  border: 'none',
                  borderRadius: '8px',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  transition: 'all 0.3s ease-in-out',
                }}
                onClick={() => setTrainingModalOpen(true)}
                disabled={localStorage.getItem('role') !== 'Admin'}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.disabled) {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.disabled) {
                    e.currentTarget.style.background = '#5E17EB';
                  }
                }}
              >
                <BsPlus style={{ marginRight: '8px' }} />
                Add Training
              </Button>

              <Button
                style={{
                  width: '100%',
                  padding: '12px',
                  background: '#5E17EB',
                  border: 'none',
                  borderRadius: '8px',
                  color: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  transition: 'all 0.3s ease-in-out',
                }}
                onClick={() => setAddUserModalOpen(true)}
                onMouseEnter={(e) => {
                  if (!e.currentTarget.disabled) {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.disabled) {
                    e.currentTarget.style.background = '#5E17EB';
                  }
                }}
                disabled={localStorage.getItem('role') !== 'Admin'}
              >
                <BsPerson style={{ marginRight: '8px' }} />
                Add User
              </Button>
            </div>
          )}

          {/* Menu Links */}
          <Nav style={{ display: 'flex', flexDirection: 'column' }}>
            {links.map((item, index) => (
              <Nav.Item key={index} style={{ marginBottom: '4px' }}>
                <OverlayTrigger placement="right" overlay={<Tooltip>{item.label}</Tooltip>}>
                  <Nav.Link
                    href="#"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      color: '#FFFFFF',
                      background: location.pathname === item.href || location.pathname.startsWith(item.href + '/') ? '#5E17EB' : 'transparent',
                      borderLeft: location.pathname === item.href || location.pathname.startsWith(item.href + '/') ? '4px solid #60A5FA' : '4px solid transparent',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease-in-out',
                      fontWeight: location.pathname === item.href || location.pathname.startsWith(item.href + '/') ? '700' : '400',
                    }}
                    onMouseEnter={(e) => {
                      const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
                      if (!isActive) {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                        e.currentTarget.style.borderLeft = '4px solid #60A5FA';
                      }
                    }}
                    onMouseLeave={(e) => {
                      const isActive = location.pathname === item.href || location.pathname.startsWith(item.href + '/');
                      if (!isActive) {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.borderLeft = '4px solid transparent';
                      }
                    }}
        onClick={async (e) => {
          e.preventDefault();
          if (item.href === '/db-shiksha/kaas/admin/log') {
            logout();
          } else if (item.external) {
            try {
              // Get KaaS credentials for silent login
              const email = localStorage.getItem('email');
              const password = localStorage.getItem('password');
              const role = localStorage.getItem('role');
              
              if (email && password) {
                // Store origin project before navigation
                sessionStorage.setItem('lastProject', window.location.href);
                
                // Check if encryption is supported
                if (isEncryptionSupported()) {
                  // Encrypt credentials before passing in URL
                  const encryptedData = await encryptCredentials({ email, password, role });
                  console.log('[KaaS TMS → External] Redirecting with encrypted credentials');
                  const separator = item.href.includes('?') ? '&' : '?';
                  window.location.href = `${item.href.startsWith('/ai-lab') ? item.href : `/ai-lab${item.href}`}${separator}silentLogin=true&data=${encodeURIComponent(encryptedData)}`;
                } else {
                  // Fallback: Use base64 encoding (basic obfuscation)
                  const basicData = btoa(JSON.stringify({ email, password, role }));
                  console.warn('[KaaS TMS → External] Using fallback encoding');
                  const separator = item.href.includes('?') ? '&' : '?';
                  window.location.href = `${item.href.startsWith('/ai-lab') ? item.href : `/ai-lab${item.href}`}${separator}silentLogin=true&data=${encodeURIComponent(basicData)}`;
                }
              } else {
                sessionStorage.setItem('lastProject', window.location.href);
                window.location.href = item.href.startsWith('/ai-lab') ? item.href : `/ai-lab${item.href}`;
              }
            } catch (error) {
              console.error('[KaaS TMS → External] Encryption failed:', error);
              Swal.fire({
                title: 'Error',
                text: 'Please try again after some time',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: 'var(--primary-color)'
              });
              // Stay on current project - don't redirect
            }
          } else {
            // Internal navigation - use React Router navigate
            navigate(item.href);
          }
        }}
                  >
                    <span style={{ 
                      display: 'flex',
                      color: '#FFFFFF',
                      minWidth: '24px',
                      transition: 'all 0.3s ease-in-out',
                    }}>
                      {item.icon}
                    </span>
                    {!collapsed && (
                      <span style={{ 
                        marginLeft: '12px', 
                        fontSize: '0.95rem',
                        fontWeight: location.pathname === item.href || location.pathname.startsWith(item.href + '/') ? '700' : '400',
                        color: '#FFFFFF',
                      }}>
                        {item.label}
                      </span>
                    )}
                  </Nav.Link>
                </OverlayTrigger>
              </Nav.Item>
            ))}
          </Nav>
        </div>
      </aside>

      {/* Main Content Area */}
      <div style={{
        marginLeft: collapsed ? '70px' : '250px',
        flex: 1,
        overflowY: 'auto',
        height: '100vh',
        transition: 'margin-left 0.3s ease'
      }}>
        {/* Your page content goes here */}
      </div>

      {/* Modals */}
      <AddTrainingModal
        isOpen={isTrainingModalOpen}
        onClose={() => setTrainingModalOpen(false)}
      />
      <AddUserModal
        show={isAddUserModalOpen}
        handleClose={() => setAddUserModalOpen(false)}
      />
    </div>
  );
};

export default TmsSidebar;
